import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN_FRONTEND || '';
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'preview';
const RELEASE = process.env.REACT_APP_RELEASE || undefined;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

if (DSN) {
  Sentry.init({
    dsn: DSN,
    environment: ENVIRONMENT,
    release: RELEASE,
    sampleRate: 1.0,
    tracesSampleRate: 0.3,
    integrations: [
      Sentry.browserTracingIntegration({
        tracePropagationTargets: [
          'localhost:8001',
          ...(BACKEND_URL ? [new RegExp(`^${BACKEND_URL.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`)] : []),
        ],
      }),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[500, 599]],
      }),
    ],
    ignoreErrors: [
      /ResizeObserver loop limit exceeded/i,
      /ResizeObserver loop completed with undelivered notifications/i,
      /AbortError/i,
      /Non-Error promise rejection captured/i,
      // Browser extensions noise
      /ChunkLoadError/i,
    ],
    beforeSend(event, hint) {
      // Drop 4xx network noise (except 401 which is interesting)
      const status = event?.request?.status;
      if (status && status >= 400 && status < 500 && status !== 401) {
        return null;
      }
      const original = hint?.originalException;
      if (original) {
        const msg = (original.message || '') + '';
        const name = (original.name || '') + '';
        if (/AbortError/i.test(name) || /AbortError/i.test(msg)) return null;
      }
      return event;
    },
  });
}

export { Sentry };
